<script>
    import options from "./SendDocumentBlock.options"
    export default options
</script>

<template>
    <nyk-form :formId="formId"
              :formGuid="formGuid"
              :apiPath="apiPath"
              :antiForgeryToken="antiForgeryToken"
              :formElements="formElements"
              :queryParams="queryParams"
              :confirmationMessage="labels.confirmationMessage"
              :submitSuccessMessage="labels.submitSuccessMessage"
              :submitErrorMessage="labels.submitErrorMessage"
              :resetAfterSubmission="true"
              :queryParamFields="queryParamFields"
              :contactAdvisorBlockId="contactAdvisorBlockId">
    </nyk-form>
</template>